module.exports = __webpack_public_path__ + "assets/images/magenta_sport_6.67b01ee10b7c262ccc614df2d479ef62.png";